import { getReportDefinitionTable } from 'reporting-data/report/relationalReportGetters';
import { getDataSourceId, getTableList } from 'reporting-snowflake/relational/utils/table-utils';
import { SourceTypes, TableDescription } from 'reporting-snowflake/relational/schema/table-records';
import { getDataTypeFamiliesForDataSource } from '../categorizationUtils/dataTypeFamilyUtils';
const getDataTypeFamilyFromRelationalReportTable = table => {
  switch (table.type) {
    case SourceTypes.HUBSPOT_EVENT:
      return getDataTypeFamiliesForDataSource(table.name);
    case SourceTypes.HUBSPOT_OBJECT:
    case SourceTypes.EVENTS_DIGEST:
    case SourceTypes.VIRTUAL_DATASOURCE:
      return getDataTypeFamiliesForDataSource(getDataSourceId(table));
    default:
      return undefined;
  }
};
export const getDataTypeFamiliesFromRelationalReport = report => {
  const definitionTable = getReportDefinitionTable(report).toJS();
  const tableDescription = TableDescription(definitionTable);
  return getTableList(tableDescription).reduce((acc, table) => {
    const dataTypeFamily = getDataTypeFamilyFromRelationalReportTable(table);
    if (dataTypeFamily) {
      return acc.concat(dataTypeFamily);
    }
    return acc;
  }, []);
};